import { useMemo } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiWhatsapp } from "@mdi/js";

import VideoJS from "../VideoJS";
import { LiveViewModel } from "../../models/LiveViewModel";
import { useToast } from "../../context/ToastContext";

type LiveCardProps = {
	data: LiveViewModel;
};

export default function LiveCard(props: LiveCardProps) {
	const navigate = useNavigate();
	const { handleToast } = useToast();

	const videoJsOption = useMemo(() => {
		return {
			autoplay: true,
			playsinline: true,
			controls: true,
			responsive: true,
			liveui: true,
			fill: true,
			sources: props.data.parametro.liveURL,
			poster: process.env.PUBLIC_URL + "/logo_escuro.png",
		};
	}, [props.data.parametro.liveURL]);

	function handleClick() {
		navigate(`/live/${props.data.vooId}`);
	}

	function handleWhatsapp() {
		navigator.clipboard.writeText(props.data.parametro.whatsAppLiveURL);
		handleToast("Live", "Link da Live copiado para a área de transferência.", 5000);
	}

	return (
		<div className="position-relative img-thumbnail" style={{ width: "100%", height: "100%" }}>
			<div
				className="position-absolute fs-6 text-white p-2 lh-1 rounded"
				style={{ zIndex: 10, top: 10, left: "50%", transform: "translateX(-50%)", background: "rgba(31, 37, 60, 0.5)", backdropFilter: "blur(5px)", cursor: "pointer" }}
				onClick={handleClick}
			>
				{props.data.cliente && `${props.data.cliente.nome} - `}
				{props.data.drone.nome}
			</div>
			{props.data.parametro?.whatsAppLiveURL && props.data.parametro?.whatsAppLiveURL !== "" && (
				<Button variant="air-dark" className="d-flex align-items-center position-absolute" onClick={handleWhatsapp} style={{ zIndex: 10, top: 10, right: 10 }}>
					<Icon path={mdiWhatsapp} size={1} />
				</Button>
			)}
			<VideoJS options={videoJsOption} className="bg-dark" style={{ width: "100%", height: "100%" }} />
		</div>
	);
}
